import { DATE_PIPE_DEFAULT_OPTIONS, DatePipeConfig } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-timezone';

@Pipe({
  name: 'utcToLocalDate'
})
export class UtcToLocalDatePipe implements PipeTransform {
  /**
   *
   */
  constructor(@Inject(DATE_PIPE_DEFAULT_OPTIONS) private defaultOptions: DatePipeConfig) {}

  public transform(value: string | Date, format: string | null = null): string | null {
    if (!value) {
      return null;
    }
    // return moment.utc(value).tz(this.defaultOptions.timezone).format(format);
    return moment.utc(value).local().format(format);
  }
}
